import { Block, type Change } from '@gitbook/slate';

import { BLOCK_PARAGRAPH } from '../types';

/**
 *  Ensures that block always contain blocks. Otherwise wrap inlines/text in paragraphs.
 */
export function wrapInlinesInParagraph(change: Change, blockKey: string) {
    const block = change.value.document.getByKey(blockKey);

    if (!block || block.object !== 'block') {
        return;
    }

    const toWrap = block.nodes.filter((n) => n.object !== 'block');

    if (toWrap.isEmpty()) {
        return;
    }

    // Wrap text/inline nodes in default block
    const wrapper = Block.create({
        type: BLOCK_PARAGRAPH,
        nodes: [],
    });

    change.insertNodeByKey(
        block.key,
        0,
        wrapper,
        // Be careful of Slate's core schema removing inlines or blocks when
        // a block contains a mix of them.
        { normalize: false }
    );

    toWrap.forEach((child, index) => {
        const isLast = index === toWrap.size - 1;

        change.moveNodeByKey(child.key, wrapper.key, index, {
            normalize: isLast,
        });
    });

    return;
}
